import { LegalInfoFields } from 'clickNgo/entities/partner/configs'

export const PARTNER_LEGAL_INFO_EDITABLE_FIELDS = [
  LegalInfoFields.CompanyLegalName,
  LegalInfoFields.LegalAddressLine1,
  LegalInfoFields.LegalAddressLine2,
  LegalInfoFields.LegalAddressLine3,
  LegalInfoFields.LegalCountry,
  LegalInfoFields.LegalCity,
  LegalInfoFields.LegalZipCode,
]
